// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --side-padding: 0 10px;
}
.experience-section {
  font-size: .8rem;
  padding: 0 20px;
}

.experience-header {
  display: flex;
  flex-direction: column; /* Align items in a column */
}

.company-name, .role-description, .role-title, .achievements {
  padding: var(--side-padding)
}

.company-name, .role-title {
  font-weight: bold;
  font-size: .9rem;
  margin: 0; /* Remove margin to eliminate space */
}

.period {
  font-style: italic;
  font-weight: normal;
  align-self: flex-end; /* Align period to the right */
  margin-top: 0; /* Ensure no additional space above the period */
  font-size: 0.8rem;
}

.role-description {
  font-size: .8rem;
  margin-top: 5px;
}

.achievements {
  list-style-type:circle;
  padding-left: 30px;
  font-size: .8rem;
  font-family:"Segoe UI";
}

@media (max-width: 768px) {
  .period {
    align-self: flex-start; /* Align period to the start for smaller screens */
    margin-top: 0;
  }
}

  `, "",{"version":3,"sources":["webpack://./src/styles/ExperienceSection.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB,EAAE,4BAA4B;AACtD;;AAEA;EACE;AACF;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAS,EAAE,qCAAqC;AAClD;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB,EAAE,8BAA8B;EACpD,aAAa,EAAE,gDAAgD;EAC/D,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE;IACE,sBAAsB,EAAE,kDAAkD;IAC1E,aAAa;EACf;AACF","sourcesContent":[":root {\r\n  --side-padding: 0 10px;\r\n}\r\n.experience-section {\r\n  font-size: .8rem;\r\n  padding: 0 20px;\r\n}\r\n\r\n.experience-header {\r\n  display: flex;\r\n  flex-direction: column; /* Align items in a column */\r\n}\r\n\r\n.company-name, .role-description, .role-title, .achievements {\r\n  padding: var(--side-padding)\r\n}\r\n\r\n.company-name, .role-title {\r\n  font-weight: bold;\r\n  font-size: .9rem;\r\n  margin: 0; /* Remove margin to eliminate space */\r\n}\r\n\r\n.period {\r\n  font-style: italic;\r\n  font-weight: normal;\r\n  align-self: flex-end; /* Align period to the right */\r\n  margin-top: 0; /* Ensure no additional space above the period */\r\n  font-size: 0.8rem;\r\n}\r\n\r\n.role-description {\r\n  font-size: .8rem;\r\n  margin-top: 5px;\r\n}\r\n\r\n.achievements {\r\n  list-style-type:circle;\r\n  padding-left: 30px;\r\n  font-size: .8rem;\r\n  font-family:\"Segoe UI\";\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .period {\r\n    align-self: flex-start; /* Align period to the start for smaller screens */\r\n    margin-top: 0;\r\n  }\r\n}\r\n\r\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
